module.exports={
  "id": "light-bites-and-sweets",
  "name": "Light bites and sweets",
  "subtext": "Satisfy any craving with a balanced mix of savory sandwiches and sweet treats",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/wdoj8vxbvy8ft3uk3ji1.jpg",
  "price": {
    "value": 17.0,
    "per_person": true,
    "starts_at": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "light-bites-includes",
        "title": "Includes",
        "description": "Savory tea sandwiches such as turkey, roast beef, ham, and cucumber cream cheese. Assorted mini desserts including macarons, brownies, cookies, and/or donuts."
      },
      {
        "id": "light-bites-size",
        "title": "Select size",
        "min_selections": 1,
        "max_selections": 1,
        "items": [
          {
            "name": "Serves up to 10",
            "price": {
              "value": 275.0,
              "per_person": false
            }
          },
          {
            "name": "Serves 10-20",
            "price": {
              "value": 399.0,
              "per_person": false
            }
          },
          {
            "name": "Serves 20-30",
            "price": {
              "value": 525.0,
              "per_person": false
            }
          },
          {
            "name": "Serves 30-40",
            "price": {
              "value": 729.0,
              "per_person": false
            }
          },
          {
            "name": "Serves 40-50",
            "price": {
              "value": 865.0,
              "per_person": false
            }
          },
          {
            "name": "Serves 50+",
            "price": {
              "value": 1050.0,
              "per_person": false
            }
          }
        ]
      }
    ]
  },
  "description": "Savory tea sandwiches such as turkey, roast beef, ham, and cucumber cream cheese. Assorted mini desserts including macarons, brownies, cookies, and/or donuts."
}
